import { render, staticRenderFns } from "./GlobalFilters.vue?vue&type=template&id=2e670ffc&scoped=true"
import script from "./GlobalFilters.vue?vue&type=script&lang=js"
export * from "./GlobalFilters.vue?vue&type=script&lang=js"
import style0 from "./GlobalFilters.vue?vue&type=style&index=0&id=2e670ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e670ffc",
  null
  
)

export default component.exports